import TemplateContents from './TemplateContents';
import { gsap } from 'gsap';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
    this.loadYouTubeAPI();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
    if (this.player) {
      this.player.destroy();
    }
    // このインスタンスに関連するすべてのGSAPトゥイーンを停止します
    gsap.killTweensOf(this.volumeProxy);
  }

  setVars() {
    super.setVars();
    this.player = null;
    // GSAPがトゥイーンするためのボリューム値を保持するプロキシオブジェクトです
    this.volumeProxy = { value: 0 };
    this.circleColors = ['#E65080', '#EF8DA5', '#E2C3A6'];

    // PC/SP切り替え用の設定
    this.videoIds = {
      pc: 'H-VUC2_Rq4w',
      sp: 'wLXRw6-Hzfs',
    };
    this.currentVideoId = null;
    this.videoInView = false;
    this.videoStarted = false;
  }

  setDom() {
    super.setDom();
    this.videoDom = document.querySelector('main.top .section1 .video');
    this.playBtn = document.querySelector('main.top .section1 .video .ui .play_btn');
    this.bars = document.querySelector('main.top .section1 .video .ui .bars');
    this.progressBar = document.querySelector('main.top .section1 .video .ui .bars .progress_bar');
    this.soundBtn = document.querySelector('main.top .section1 .video .ui .sound_btn');
    this.h2 = document.querySelector('main.top .section1 h2');
    this.h2ItemAll = document.querySelectorAll('main.top .section1 h2 .item');
    this.h2ItemChildAll = document.querySelectorAll('main.top .section1 h2 .item .item_child');
    this.h2ItemCircleAll = document.querySelectorAll('main.top .section1 h2 .item .item_circle');

    this.textPAll = document.querySelectorAll('main.top .section1 .text p');
    
    this.pack.initRandomPop(
      this.h2ItemAll,
      this.h2ItemCircleAll,
      this.h2ItemChildAll,
      this.circleColors
    );
  }

  initEvents() {
    super.initEvents();

    // play / pause
    this.playBtn.addEventListener('click', () => {
      if (!this.player || typeof this.player.getPlayerState !== 'function') return;
      if (this.player.getPlayerState() === YT.PlayerState.PLAYING) {
        this.player.pauseVideo();
      } else {
        this.player.playVideo();
      }
    });

    // seek
    const seek = (e) => {
      if (!this.player || typeof this.player.getDuration !== 'function') return;
      const rect = this.bars.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      this.player.seekTo(this.player.getDuration() * ratio, true);
    };
    this.bars.addEventListener('mousedown', seek);
    this.bars.addEventListener('touchstart', seek, { passive: true });

    this.soundBtn.addEventListener('click', (event) => {
      if (!this.player || typeof this.player.getVolume !== 'function') return;

      // 実行中のボリュームアニメーションがあればキャンセルして、重複を防ぎます
      gsap.killTweensOf(this.volumeProxy);

      const isMuted = this.soundBtn.classList.contains('off');
      let dr = .5;

      if (isMuted) {
        // フェードイン処理
        this.soundBtn.classList.remove('off');
        this.volumeProxy.value = 1;
        this.player.setVolume(this.volumeProxy.value);
        this.player.unMute();

        gsap.to(this.volumeProxy, {
          value: 100,
          duration: dr,
          ease: 'linear.out',
          onUpdate: () => this.player.setVolume(this.volumeProxy.value),
        });
      } else {
        // フェードアウト処理
        this.soundBtn.classList.add('off');
        this.volumeProxy.value = this.player.getVolume(); // 現在のボリュームから開始

        gsap.to(this.volumeProxy, {
          value: 0,
          duration: dr, // 1秒かけてフェードアウト
          ease: 'linear.out',
          onUpdate: () => this.player.setVolume(this.volumeProxy.value),
          onComplete: () => this.player.mute(),
        });
      }
    });
  }

  loadYouTubeAPI() {
    // APIがすでに読み込まれているかチェック
    if (window.YT && window.YT.Player) {
      this.createPlayer();
      return;
    }

    // 既に設定されているコールバックがあれば保持する
    const prevCallback = window.onYouTubeIframeAPIReady;

    // APIのグローバルコールバックを設定（既存の処理があれば一緒に実行）
    window.onYouTubeIframeAPIReady = () => {
      if (typeof prevCallback === 'function') {
        prevCallback();
      }
      this.createPlayer();
    };

    // scriptタグの重複挿入を防ぐ
    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  createPlayer() {
    this.currentVideoId = this.getVideoId();

    this.player = new YT.Player('player2', {
      videoId: this.currentVideoId,
      playerVars: {
        autoplay: 1,
        mute: 1,
        // loop: 1, // loadVideoByIdを使用するため、ネイティブのループではなくイベントで制御します
        // playlist: 'H-VUC2_Rq4w',
        playsinline: 1,
        controls: 0,
        disablekb: 1,
        modestbranding: 1,
        rel: 0, // 関連動画を非表示
      },
      events: {
        onReady: this.onPlayerReady.bind(this),
        onStateChange: this.onPlayerStateChange.bind(this),
      },
    });
  }

  getVideoId() {
    return window.innerWidth <= this.pack.BP ? this.videoIds.sp : this.videoIds.pc;
  }

  onPlayerStateChange(event) {
    // const stateNames = { '-1': 'UNSTARTED', 0: 'ENDED', 1: 'PLAYING', 2: 'PAUSED', 3: 'BUFFERING', 5: 'CUED' };
    // console.log('[YT stateChange]', stateNames[event.data] ?? event.data, new Date().toISOString());

    if (event.data === YT.PlayerState.ENDED) {
      this.player.seekTo(0);
      this.player.playVideo();
    }
    if (event.data === YT.PlayerState.PLAYING) {
      this.playBtn.classList.remove('paused');
    } else if (event.data === YT.PlayerState.PAUSED) {
      this.playBtn.classList.add('paused');
    }
  }

  onPlayerReady(event) {
    event.target.playVideo();
    event.target.mute(); // autoplayのためにミュートを確実にする
    this.soundBtn.classList.add('off');
    // プロキシオブジェクトの初期値を設定します
    if (this.player.isMuted()) {
      this.volumeProxy.value = 0;
    } else {
      this.volumeProxy.value = this.player.getVolume();
    }
  }

  start() {}
  
  showH2(){
    this.pack.playRandomPop(this.h2ItemAll, this.h2ItemCircleAll, this.h2ItemChildAll);
  }
  
  scrollHandler() {
    if(!this.h2.classList.contains('show')){
      if(this.h2.getBoundingClientRect().top <= this.sh - 100){
        this.h2.classList.add('show');
        this.showH2();
      }
    }

    if (!this.videoStarted && this.videoDom && this.player && typeof this.player.seekTo === 'function') {
      const rect = this.videoDom.getBoundingClientRect();
      const inView = rect.top < this.sh && rect.bottom > 0;
      if (inView && !this.videoInView) {
        this.player.seekTo(0);
        this.player.playVideo();
        this.videoStarted = true;
      }
      this.videoInView = inView;
    }

    this.textPAll.forEach((p) => {
      if (!p.classList.contains('show')) {
        if (p.getBoundingClientRect().top <= this.sh - 200) {
          p.classList.add('show');
        }
      }
    });
  }

  enterframe() {}

  enterframeThinOut() {
    if (!this.progressBar || !this.player || typeof this.player.getCurrentTime !== 'function') return;
    if (this.player.getPlayerState() !== YT.PlayerState.PLAYING) return;
    const duration = this.player.getDuration();
    if (!duration) return;
    gsap.set(this.progressBar, { scaleX: this.player.getCurrentTime() / duration });
  }

  executeResize() {
    super.executeResize();

    // リサイズ時に動画IDをチェックして切り替える
    if (this.player && typeof this.player.loadVideoById === 'function') {
      const newId = this.getVideoId();
      if (this.currentVideoId !== newId) {
        this.currentVideoId = newId;
        this.player.loadVideoById(newId);
        // loadVideoById後にミュートが外れる場合があるため、UIの状態に合わせて再設定
        if (this.soundBtn.classList.contains('off')) {
          this.player.mute();
        }
      }
    }
  }
}
